<template>
    <div class="max-width-content">

        <div class="flex items-center justify-between">
            <breadcrumbs>
                <inertia-link :href="route('admin.company-users.index')">Werkgevergebruikers</inertia-link>
                <i class="fad fa-chevron-right"></i>
                {{ user.fullName }}
            </breadcrumbs>

            <div v-if="!user.deleted_at">
                <link-button :href="route('admin.company-users.edit', user.id)" icon="pencil" class="bg-white">Wijzig</link-button>
                <confirm-button method="delete" :href="route('admin.company-users.destroy', user.id)" icon="trash" class="bg-white hover:bg-red-600 hover:text-white">Verwijder</confirm-button>
            </div>
        </div>

        <div class="mt-8 flex py-5">
            <div class="w-32" v-if="user.avatar">
                <img :src="user.avatar" class="object-cover w-full rounded-full" />
            </div>
            <div class="w-3/4 ml-10">
                <h1 class="text-5xl text-teal-800 mr-1 leading-tight">{{ user.fullName }}</h1>
                <div>{{ user.email }}</div>
                
                <div class="flex mt-2">
                    <div>functie: </div>
                    <div>{{ user.jobtitle || 'onbekend' }}</div>
                </div>

            </div>
        </div>
        

    </div>
</template>

<script>
import Layout from "@/admin/Shared/Layout";
import Helpers from "@/admin/Mixins/GeneralHelpers.js";
import Breadcrumbs from "@/admin/Shared/Breadcrumbs";
import LinkButton from "@/admin/Shared/LinkButton";
import ConfirmButton from "@/admin/Shared/ConfirmButton";

export default {
    metaInfo() {
        return { title: 'Werkgevergebruikers > ' + this.user.fullName };
    },
    

    layout: Layout,

    mixins: [Helpers],

    components: { Breadcrumbs, LinkButton, ConfirmButton },

    props: {
        user: {
            Type: Object
        }
    },
    data() {
        return {};
    },
    methods: {}
};
</script>
